/* Complete the routine: track selected rows + their chosen variant, add every
   selected item to the bag in a single /cart/add.js request, and confirm with
   the same plum toast used by the recommendations carousel. */
(function () {
  var CHECK_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>';

  /* ----- shared toast (one per page) ------------------------------------- */
  var toastEl = null;
  var toastTimer = null;

  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ctr-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML =
        '<span class="ctr-toast__dot" aria-hidden="true">' + CHECK_SVG + '</span>' +
        '<span class="ctr-toast__msg"></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('.ctr-toast__msg').textContent = message;
    toastEl.classList.remove('show');
    void toastEl.offsetWidth; /* restart the keyframe */
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ----- per-section wiring ---------------------------------------------- */
  document.querySelectorAll('[data-ctr]').forEach(function (root) {
    var list = root.querySelector('[data-ctr-list]');
    var submit = root.querySelector('[data-ctr-submit]');
    var label = root.querySelector('[data-ctr-label]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ctr-card]'));
    if (!submit) return;

    var baseLabel = label ? label.textContent.trim() : 'Add selected to bag';

    /* The checkbox carries the selected variant id; a shade change keeps it in
       sync so the right variant is added even before re-checking. */
    cards.forEach(function (card) {
      var check = card.querySelector('[data-ctr-check]');
      var variant = card.querySelector('[data-ctr-variant]');
      if (check && variant) {
        variant.addEventListener('change', function () { check.value = variant.value; });
      }
      if (check) check.addEventListener('change', sync);

      /* Clicking anywhere on the card toggles selection, except the shade
         picker (which operates its own dropdown) and the checkbox/label
         itself (which already toggles natively). */
      card.addEventListener('click', function (e) {
        if (!check || check.disabled) return;
        if (e.target.closest('.ctr-select') || e.target.closest('.ctr-card__select')) return;
        check.checked = !check.checked;
        sync();
      });
    });

    function selected() {
      return cards
        .map(function (card) { return card.querySelector('[data-ctr-check]'); })
        .filter(function (c) { return c && c.checked && c.value; });
    }

    function sync() {
      var count = selected().length;
      submit.disabled = count === 0;
      if (label) label.textContent = count > 0 ? baseLabel + ' (' + count + ')' : baseLabel;
    }

    /* --- entrance animation when scrolled into view --- */
    if (list && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { list.classList.add('animate'); io.disconnect(); }
        });
      }, { threshold: 0.15 });
      io.observe(list);
    }

    /* --- AJAX add selected to bag --- */
    submit.addEventListener('click', function () {
      var picks = selected();
      var items = picks.map(function (c) { return { id: c.value, quantity: 1 }; });
      if (!items.length) return;

      submit.disabled = true;
      submit.classList.add('is-loading');
      if (label) label.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error((result.data && result.data.description) || 'Could not add items');
          toast(items.length > 1 ? 'Added ' + items.length + ' to bag' : 'Added to bag');
          document.dispatchEvent(new CustomEvent('ctr:added', { detail: result.data }));
          /* clear selection so the bundle isn't accidentally added twice */
          picks.forEach(function (c) { c.checked = false; });
        })
        .catch(function (err) {
          toast((err && err.message) || 'Could not add to bag');
        })
        .finally(function () {
          submit.classList.remove('is-loading');
          sync();
        });
    });

    sync();
  });
})();